import React from 'react';
import '../Styles/OurVisionPage.css';
//import Lottie from "lottie-react";
//import anime11 from "../animations/anime11.json";

const OurVision = () => {
    return (
        <div className="vision-container">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="vision-details">
                <div className="content-wrapper">
                    <h2>VİZYONUMUZ</h2>
                    <p>
                        Vizyonumuz, tıbbi görüntüleme eğitiminde sanal gerçeklik teknolojisinin lideri olarak, global ölçekte tanınan ve tercih edilen bir eğitim platformu olmaktır. Yenilikçi projeler ve eğitim programları ile sektörde fark yaratarak, sağlık alanında erken teşhis ve tedavi süreçlerinin gelişimine katkıda bulunmayı amaçlıyoruz. Ayrıca, meme sağlığı, mamografi, Kendi Kendine Meme Muayenesi (KKMM) ve Klinik Meme Muayenesi (KMM) konularında farkındalık yaratarak kadınların sağlık bilincini artırmayı hedefliyoruz. Kadın girişimciliğini destekleyerek iş dünyasında kadınların daha aktif rol almasını sağlamak ve bu alanda lider projeler geliştirmek de vizyonumuzun önemli bir parçasıdır.
                    </p>
                </div>
                </div>
            </section>

            {/* Vision Details
            <section className="vision-details">
                <div className="vision-details-background">
                    <Lottie animationData={anime11} loop={true} className="vision-background-animation"
                            style={{width: '50%', height: '50%'}}/>
                </div>
                <div className="content-wrapper">
                    <h2>A Future Without Boundaries</h2>
                    <p>
                        We envision a world where educational barriers are eliminated. Our innovative approach ensures
                        that everyone, regardless of background or location, can access high-quality educational
                        experiences.
                    </p>
                    <h2>Empowering Lifelong Learners</h2>
                    <p>
                        Our goal is to inspire curiosity and foster continuous growth. By integrating advanced VR
                        technology with proven learning methods, we empower individuals to pursue excellence at every
                        stage of life.
                    </p>
                    <h2>Shaping Tomorrow’s Leaders</h2>
                    <p>
                        Through immersive learning experiences, we aim to equip future leaders with the skills and
                        vision needed to drive global innovation and positive change.
                    </p>
                    <button className="vision-button">Explore Our Vision</button>
                </div>
            </section>
            */}
        </div>
    );
};

export default OurVision;